import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx-home-circle',
        link: '/',
        roles: [1],
    },
    {
        id: 3,
        label: 'Meus Arquivos',
        icon: 'bx-file',
        link: '/filemanager',
    },
    {
        id: 4,
        label: 'Usuários',
        icon: 'bx-user-circle',
        link: '/usuarios',
        roles: [1, 2],
    },
    {
        id: 5,
        label: 'Grupos de Usuário',
        icon: 'bx-group',
        link: '/grupousuario',
        roles: [1, 2],
    },
    {
        id: 6,
        label: 'Cadastros',
        icon: 'bx-cog',
        superAdminOnly: true,
        subItems: [
            {
                id: 601,
                label: 'Empresas',
                link: '/cadastros/empresas',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 602,
                label: 'Parceiros',
                link: '/cadastros/parceiros',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 603,
                label: 'Repositórios',
                link: '/cadastros/repositorios',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 604,
                label: 'Planos',
                link: '/cadastros/planos',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 605,
                label: 'Categorias GED',
                link: '/cadastros/categorias-ged',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 606,
                label: 'Competências GED',
                link: '/cadastros/competencias-ged',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 607,
                label: 'Tipos de Documento GED',
                link: '/cadastros/tipos-documento-ged',
                parentId: 6,
                superAdminOnly: true,
            },
            {
                id: 608,
                label: 'Usuário-Repositório',
                link: '/cadastros/usuario-repositorio',
                parentId: 6,
                superAdminOnly: true,
            },
        ],
    },
    {
        id: 7,
        label: 'Alterar Senha',
        icon: 'bx-lock',
        link: '/change-password',
    },
    {
      id: 8,
      label: 'Sair',
      icon: 'bx-log-out',
      funcaoSair: true,
  },
];

